import React from 'react';
import { DeviceType } from 'contexts/device';
import classNames from 'classnames/bind';
import { TripType } from 'contexts/searchParams';
import {
  getPeriodInfoStr,
  getPeriodTextForPc,
  IChartBarData,
} from '../utilChart';
import styles from './chartBar.module.scss';

const cx = classNames.bind(styles);

interface IDateTextProps {
  device: DeviceType;
  trip: TripType;
  period: number;
  barTotalWidth: number;
  mouseOverItem: IChartBarData | null;
  selectedBarItem: IChartBarData | undefined | null;
  selectedBarOrderIndex: number;
  barDataList: IChartBarData[];
}

const DateText = (props: IDateTextProps) => {
  const {
    device,
    trip,
    period,
    mouseOverItem,
    selectedBarItem,
    barDataList,
  } = props;

  return (
    <div className={cx('duration')}>
      {/* 날짜 */}
      {device === DeviceType.MOBILE
        ? getPeriodInfoStr(trip, barDataList, period)
        : getPeriodTextForPc(
            trip,
            period,
            mouseOverItem || selectedBarItem || null,
          )}
    </div>
  );
};

export default DateText;
